import { render } from "./ChatCircle.vue?vue&type=template&id=598901d6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ChatCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "598901d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('598901d6', __exports__)) {
    api.reload('598901d6', __exports__)
  }
  
  module.hot.accept("./ChatCircle.vue?vue&type=template&id=598901d6", () => {
    api.rerender('598901d6', render)
  })

}


export default __exports__